$(document).ready(function(){
$('.brands-main-inner').slick({
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 5, 
  nextArrow: '<button class="slick-next slick-arrow" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1487 14.6545L5.85141 24.1254L5.85141 19.0091L10.4378 14.6545L5.85141 10.2657L5.85141 5.14937L15.1487 14.6545Z" fill="#D9D9D9"/></svg></button>',
  prevArrow: '<button class="slick-prev slick-arrow" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.85126 14.6199L15.1486 5.14905L15.1486 10.2653L10.5622 14.6199L15.1486 19.0088L15.1486 24.125L5.85126 14.6199Z" fill="#D9D9D9"/></svg></button>',
  responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows:false,
          infinite: false,
        }
      }
    ]
});


$('.real-value-main').slick({
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1, 
  nextArrow: '<button class="slick-next slick-arrow" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1487 14.6545L5.85141 24.1254L5.85141 19.0091L10.4378 14.6545L5.85141 10.2657L5.85141 5.14937L15.1487 14.6545Z" fill="#D9D9D9"/></svg></button>',
  prevArrow: '<button class="slick-prev slick-arrow" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.85126 14.6199L15.1486 5.14905L15.1486 10.2653L10.5622 14.6199L15.1486 19.0088L15.1486 24.125L5.85126 14.6199Z" fill="#D9D9D9"/></svg></button>',
   responsive: [     
      {
        breakpoint: 749,
        settings: {         
          dots: true,
          arrows:false,          
        }
      }
    ]
}); 

//*******//
/*
window.addEventListener("resize", function() {
  if (window.innerWidth < 990) {
    $(".contact_info_livechat").insertBefore($("header.header"));
  } else {
    $(".contact_info_livechat").insertAfter($(".search_predctive"));
  }
}); 

if ($(window).width() < 990) {
   $(".contact_info_livechat").insertBefore($("header.header"));
}  
*/
//*******//  

//*******//  
window.addEventListener("resize", function() {
  if (window.innerWidth < 990) {
    $(".banner_content_right").insertAfter($(".home_top_main-banner"));
  } else {
    $(".banner_content_right").insertAfter($(".banner_content_left"));
  }
}); 

if ($(window).width() < 990) {
    $(".banner_content_right").insertAfter($(".home_top_main-banner"));
}
//*******//

//*******//  
window.addEventListener("resize", function() {
  if (window.innerWidth < 990) {
    $(".why-choose-section .why-choose-title").insertBefore($(".why-choose-col.col1s"));
  } else {
    $(".why-choose-section .why-choose-title").insertBefore($(".why-choose-section .why-choose-inner"));
  }
}); 

if ($(window).width() < 990) {
    $(".why-choose-section .why-choose-title").insertBefore($(".why-choose-col.col1s"));
}
//*******//   
 

//*******//
window.addEventListener("resize", function() {
if (window.innerWidth < 990) {  
$('.final-drive-toolbox .why-choose-inner').slick({
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 2, 
  centerMode: true,
  centerPadding: '60px',
  nextArrow: '<button class="slick-next slick-arrow" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1487 14.6545L5.85141 24.1254L5.85141 19.0091L10.4378 14.6545L5.85141 10.2657L5.85141 5.14937L15.1487 14.6545Z" fill="#D9D9D9"/></svg></button>',
  prevArrow: '<button class="slick-prev slick-arrow" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.85126 14.6199L15.1486 5.14905L15.1486 10.2653L10.5622 14.6199L15.1486 19.0088L15.1486 24.125L5.85126 14.6199Z" fill="#D9D9D9"/></svg></button>',
  responsive: [     
      {
        breakpoint: 749,
        settings: {         
          dots: true,
          arrows:false,
          infinite: false,
          centerMode: false,
          slidesToShow: 1, 
        }
      }
    ]
}); 
} 
});   

if ($(window).width() < 990) {  
$('.final-drive-toolbox .why-choose-inner').slick({
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 2, 
  centerMode: true,
  centerPadding: '60px',
  nextArrow: '<button class="slick-next slick-arrow" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1487 14.6545L5.85141 24.1254L5.85141 19.0091L10.4378 14.6545L5.85141 10.2657L5.85141 5.14937L15.1487 14.6545Z" fill="#D9D9D9"/></svg></button>',
  prevArrow: '<button class="slick-prev slick-arrow" type="button" style=""><svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.85126 14.6199L15.1486 5.14905L15.1486 10.2653L10.5622 14.6199L15.1486 19.0088L15.1486 24.125L5.85126 14.6199Z" fill="#D9D9D9"/></svg></button>',
  responsive: [     
      {
        breakpoint: 749,
        settings: {         
          dots: true,
          arrows:false,
          infinite: false,
          centerMode: false,
          slidesToShow: 1, 
        }
      }
    ]
});
}  
//*******//  


//*******//  
window.addEventListener("resize", function() {
  if (window.innerWidth < 990) {
    $(".woc-col-two").insertAfter($(".woc-col-one-content h3"));
  } else {
    $(".woc-col-two").insertAfter($(".woc-col-one"));
  }
}); 

if ($(window).width() < 990) {
   $(".woc-col-two").insertAfter($(".woc-col-one-content h3"));
}
//*******//  


//*******//  
window.addEventListener("resize", function() {
  if (window.innerWidth < 990) {
    $(".footer-block__image_copyright").insertAfter($(".footer__content-top"));
  } else {
    $(".footer-block__image_copyright").insertAfter($(".footer-block__image_text"));
  }
}); 

if ($(window).width() < 990) {
   $(".footer-block__image_copyright").insertAfter($(".footer__content-top"));
}
//*******//   


//*******//  
window.addEventListener("resize", function() {
  if (window.innerWidth < 749) {
    $(".multi02s").insertAfter($(".multi01s .footer-block__details-content"));
  } else {
    $(".multi02s").insertAfter($(".multi01s"));
  }
}); 

if ($(window).width() < 749) {
  $(".multi02s").insertAfter($(".multi01s .footer-block__details-content"));
  
  $(".product__description.rte").insertAfter($(".product__info-container"));
}
//*******// 
  
  
});  



$(document).ready(function () {
  if ($(window).width() < 990) {
    $(".insta_title").click(function () {
        if ($('.insta_content').is(':visible')) {
            $(".insta_content").slideUp(300);
            $(".plusminus").removeClass('opent');
        }
        if ($(this).next(".insta_content").is(':visible')) {
            $(this).next(".insta_content").slideUp(300);
            $(this).children(".plusminus").removeClass('opent');
        } else {
            $(this).next(".insta_content").slideDown(300);
            $(this).children(".plusminus").addClass('opent');
        }
    });


    $(".contact-support-text h2").click(function () {
        if ($('.support-text-inn').is(':visible')) {
            $(".support-text-inn").slideUp(300);
            $(".plusminus").removeClass('opent');
        }
        if ($(this).next(".support-text-inn").is(':visible')) {
            $(this).next(".support-text-inn").slideUp(300);
            $(this).children(".plusminus").removeClass('opent');
        } else {
            $(this).next(".support-text-inn").slideDown(300);
            $(this).children(".plusminus").addClass('opent');
        }
    });
    
}      
});